// client/src/styles/app/theme/theme.js

const theme = {
    // Color Palette
    colors: {
      primary: {
        main: '#03063d',      // Deep blue - main brand color
        light: '#2d3069',     // Lighter blue for hover states
        dark: '#020318',      // Darker blue for active states
        contrast: '#ffffff'    // White text on primary colors
      },
      secondary: {
        main: '#ff6900',      // Orange - for calls to action
        light: '#ff8533',     // Lighter orange for hover states
        dark: '#cc5500',      // Darker orange for active states
        contrast: '#ffffff'    // White text on secondary colors
      },
      status: {
        success: '#00d084',   // Green for success/operational
        warning: '#ffb100',   // Yellow for warnings/in-progress
        error: '#dc3545',     // Red for errors/stopped
        info: '#0dcaf0'       // Blue for information
      },
      neutral: {
        white: '#ffffff',
        black: '#000000',
        background: {
          main: '#f8f9fa',    // Main background color
          light: '#ffffff',    // Light background for cards
          dark: '#e9ecef'     // Dark background for hover states
        },
        border: {
          light: '#dee2e6',   // Light border color
          main: '#ced4da',    // Main border color
          dark: '#adb5bd'     // Dark border color
        },
        text: {
          primary: '#212529',   // Primary text color
          secondary: '#6c757d', // Secondary text color
          disabled: '#adb5bd',  // Disabled text color
          hint: '#868e96'       // Hint text color
        }
      }
    },
  
    // Typography
    typography: {
      fontFamily: {
        body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        display: 'SF Pro Display, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        mono: 'SF Mono, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
      },
      fontSizes: {
        xs: '0.75rem',     // 12px
        sm: '0.875rem',    // 14px
        base: '1rem',      // 16px
        lg: '1.125rem',    // 18px
        xl: '1.25rem',     // 20px
        '2xl': '1.5rem',   // 24px
        '3xl': '1.875rem', // 30px
        '4xl': '2.25rem',  // 36px
        '5xl': '3rem'      // 48px
      },
      fontWeights: {
        light: 300,
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700
      },
      lineHeights: {
        tight: 1.25,
        normal: 1.5,
        relaxed: 1.75
      }
    },
  
    // Spacing
    spacing: {
      0: '0',
      1: '0.25rem',      // 4px
      2: '0.5rem',       // 8px
      3: '0.75rem',      // 12px
      4: '1rem',         // 16px
      5: '1.5rem',       // 24px
      6: '2rem',         // 32px
      8: '3rem',         // 48px
      10: '4rem',        // 64px
      12: '6rem'         // 96px
    },
  
    // Breakpoints (mobile-first)
    breakpoints: {
      xs: '0px',
      sm: '576px',      // Small devices
      md: '768px',      // Medium devices (tablets)
      lg: '992px',      // Large devices (desktops)
      xl: '1200px',     // Extra large devices
      xxl: '1400px'     // Extra extra large devices
    },
  
    // Border Radius
    borderRadius: {
      none: '0',
      sm: '0.125rem',    // 2px
      base: '0.25rem',   // 4px
      md: '0.375rem',    // 6px
      lg: '0.5rem',      // 8px
      xl: '0.75rem',     // 12px
      full: '9999px'     // Fully rounded
    },
  
    // Shadows
    shadows: {
      none: 'none',
      sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
      md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
      lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
      xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)'
    },
  
    // Z-index
    zIndex: {
      behind: -1,
      base: 0,
      raised: 1,
      dropdown: 1000,
      sticky: 1020,
      fixed: 1030,
      modalBackdrop: 1040,
      modal: 1050,
      popover: 1060,
      tooltip: 1070
    },
  
    // Transitions
    transitions: {
      base: '0.2s ease-in-out',
      fast: '0.1s ease-in-out',
      slow: '0.3s ease-in-out'
    },
  
    // Layout
    container: {
      padding: {
        sm: '1rem',
        lg: '2rem'
      },
      maxWidth: {
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px'
      }
    }
  };
  
  // Helper function to access theme values
  export const getThemeValue = (path) => {
    return path.split('.').reduce((obj, key) => obj && obj[key], theme);
  };
  
  export default theme;